import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';

import { SnTooltipModule } from '@lib/ui/tooltip';
import { TranslationModule } from '@lib/translation';

import { AppliancesStatusComponent } from './components/appliances-status/appliances-status.component';
import { SnCameraStatsComponent } from './components/camera-stats';

@NgModule({
  imports: [
    CommonModule,
    // Libs
    SnTooltipModule,
    MatChipsModule,
    TranslationModule,
  ],
  exports: [SnCameraStatsComponent, AppliancesStatusComponent],
  declarations: [SnCameraStatsComponent, AppliancesStatusComponent],
})
export class SnStatsModule {}
